import { render } from "./CommunityAdminPainPoint.vue?vue&type=template&id=0d23f5a8&scoped=true"
import script from "./CommunityAdminPainPoint.vue?vue&type=script&lang=js"
export * from "./CommunityAdminPainPoint.vue?vue&type=script&lang=js"

import "./CommunityAdminPainPoint.vue?vue&type=style&index=0&id=0d23f5a8&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d23f5a8"]])

export default __exports__